class OurHistory {
  constructor(historyObject, mobileBridge) {
    this._history = historyObject;
    this._mobileBridge = mobileBridge;
    this._paths = [];
    this._position = 0;
  }

  createHref = (path) => {
    return this._history.createHref(path);
  }

  get location() {
    return this._history.location;
  }

  get paths() {
    return this._paths;
  }

  get savedLocation() {
    return this._savedLocation;
  }

  saveCurrentLocation() {
    this._savedLocation = this.location;
  }

  clearSavedLocation(location) {
    this._savedLocation = null;
  }

  getCurrentLocation = () => {
    return this._history.location;
  }

  parseParameters() {
    const location = this.getCurrentLocation();
    const slicedLocation = location.pathname.split('/');
    let params = {};
    for (let i = 0; i < slicedLocation.length; i++) {
      if (i > 0) {
        if (slicedLocation[i] == 'edit') {
          params['edit'] = 'edit';
        }
        else {
          let name = slicedLocation[i - 1];
          if (name) {
            const value = parseInt(slicedLocation[i], 10);
            if (name == 'bulk-assign') {
              params['bulk_assign'] = slicedLocation[i];
            }
            else if (name == 'project-types') {
              params['project_type_id'] = slicedLocation[i];
            }
            else if (name == 'project-template') {
              params['project_template_id'] = slicedLocation[i];
            }
            else if (!isNaN(value) || slicedLocation[i] == 'all') {
              if (name.lastIndexOf('s') == name.length - 1) {
                name = name.substring(0, name.length - 1);
              }
              name += '_id';
              params[name] = slicedLocation[i] == 'all' ? 'all' : value;
            }
          }
        }
      }
    }
    return { currentPath: location.pathname, params: params };
  }

  getState = () => {
    return this._paths[this._position] ? this._paths[this._position].state : null;
  }

  go = (n) => {
    let position = this._position += n;
    if (position < 0 || position >= this._paths.length) {
      throw new Error('invalid position for history go ' + position);
    }
    this._position = position;
    return this._history.go(n);
  }

  goBack = (state) => {
    if (this._paths.length == 1) {
      if (this.isRoot()) {
        // send back to native app

        if (!window.broadcaster) {
          this.go('/dashboard');
        }
        else {
          this._mobileBridge.fireNativeEvent('native.navigateTo', {
            data: {
              notification_type: 'Back',
            },
          });
        }
      }
      else {
        this._paths.pop();
        this._position = this._paths.length - 1;
        return this._history.goBack();
      }
    } else {
      this._paths.pop();
      this._position = this._paths.length - 1;

      if (state) {
        let pathObject = this.buildPathObject(this._paths[this._position], state);
        this._paths[this._position] = pathObject;
      }
  
      return this._history.goBack();
    }
  }

  goForward = () => {
    return this._history.goForward();
  }

  listen = (historyListener) => {
    return this._history.listen(historyListener);
  }

  push = (path, state) => {
    let pathObject = this.buildPathObject(path, state); 
    this._paths.push(pathObject);
    this._position = this._paths.length - 1;

    // propagate the state of matching paths
    for (let i = 0; i < this._paths.length - 1; i++){
      if (this._paths[i].pathname == this._paths[this._paths.length - 1].pathname) {
        if (this._paths[i].state) {
          this._paths[this._paths.length - 1].state = {};
          Object.assign(this._paths[this._paths.length - 1].state, this._paths[i].state);
          break;
        }
      }
    }

    return this._history.push(path.state ? path.pathname : path);
  }

  replace = (path, state) => {
    let pathObject = this.buildPathObject(path, state);
    this._paths.pop();
    this._paths.push(pathObject);
    return this._history.replace(path.state ? path.pathname : path);
  }

  setState = (state) => {
    if (state) {
      if (this._paths && this._paths.length > 0) {
        if (!this._paths[this._paths.length - 1].state) {
          this._paths[this._paths.length - 1].state = {};
        }
        Object.assign(this._paths[this._paths.length - 1].state, state);
        // do the same for all paths that match the path name

        for (let i = 0; i < this._paths.length - 1; i++){
          if (this._paths[i].pathname == this._paths[this._paths.length - 1].pathname) {
            if (!this._paths[i].state) {
              this._paths[i].state = {};
            }
            Object.assign(this._paths[i].state, state);
          }
        }
      }
    }
  }

  clearState = () => {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
    let path = this._paths.pop();
    if (path) {
      if (path.state) {
        delete path.state;
      }
      this._paths.push(path);
    }
  }

  isRoot() {
    if (this._paths.length) {
      const path = this._paths[this._paths.length - 1];
      if (typeof path == 'object'
          && 'isRoot' in path) {
        return path.isRoot;
      }
    }
    return false;
  }
  
  buildPathObject(path, state) {
    let pathObject = {};
    if (typeof path == 'string') {
      pathObject.pathname = path;
    } else {
      Object.assign(pathObject, path);
    }
    if (!pathObject.search && pathObject.pathname) {
      let searchStart = pathObject.pathname.indexOf('?');
      if (searchStart >= 0) {
        const pathname = pathObject.pathname;
        pathObject.pathname = pathname.substring(0, searchStart);
        pathObject.search = pathname.substring(searchStart);
      }
    }
    if (state) {
      if (!pathObject.state) {
        pathObject.state = {};
      }
      Object.assign(pathObject.state, state);
    }
    return pathObject;
  }

}

export default OurHistory;



// WEBPACK FOOTER //
// ./src/helpers/OurHistory/OurHistory.js